import L from "leaflet";
import newFlightMarkerDefault from "./../../../../assests/map-markers/newFlightMarkerDefault.svg";
import newFlightMarkerDefaultSelected from "./../../../../assests/map-markers/newFlightMarkerDefaultSelected.svg";
import newFlightMarkerDelayed from "./../../../../assests/map-markers/newFlightMarkerDelayed.svg";
import newFlightMarkerDelayedSelected from "./../../../../assests/map-markers/newFlightMarkerDelayedSelected.svg";
import newFlightMarkerOnTime from "./../../../../assests/map-markers/newFlightMarkerOnTime.svg";
import newFlightMarkerOnTimeSelected from "./../../../../assests/map-markers/newFlightMarkerOnTimeSelected.svg";

const flightIcons = {
  onTime: new L.Icon({
    iconUrl: newFlightMarkerOnTime,
    iconSize: [35, 35],
    iconAnchor: [17.5, 17.5],
    tooltipAnchor: [1, -15],
  }),
  early: new L.Icon({
    iconUrl: newFlightMarkerOnTime,
    iconSize: [35, 35],
    iconAnchor: [17.5, 17.5],
    tooltipAnchor: [1, -15],
  }),
  delayed: new L.Icon({
    iconUrl: newFlightMarkerDelayed,
    iconSize: [35, 35],
    iconAnchor: [17.5, 17.5],
    tooltipAnchor: [1, -15],
  }),
  default: new L.Icon({
    iconUrl: newFlightMarkerDefault,
    iconSize: [35, 35],
    iconAnchor: [17.5, 17.5],
    tooltipAnchor: [1, -15],
  }),
};

const flightIconsSelected = {
  onTimeSelected: new L.Icon({
    iconUrl: newFlightMarkerOnTimeSelected,
    iconSize: [40, 40],
    iconAnchor: [20, 20],
    tooltipAnchor: [1, -17],
  }),
  earlySelected: new L.Icon({
    iconUrl: newFlightMarkerOnTimeSelected,
    iconSize: [40, 40],
    iconAnchor: [20, 20],
    tooltipAnchor: [1, -17],
  }),
  delayedSelected: new L.Icon({
    iconUrl: newFlightMarkerDelayedSelected,
    iconSize: [40, 40],
    iconAnchor: [20, 20],
    tooltipAnchor: [1, -17],
  }),
  defaultSelected: new L.Icon({
    iconUrl: newFlightMarkerDefaultSelected,
    iconSize: [40, 40],
    iconAnchor: [20, 20],
    tooltipAnchor: [1, -15],
  }),
};

export function getFlightIcon(status: string, selected: boolean) {
  if (selected) {
    switch (status) {
      case "onTime":
      case "ON_TIME":
        return flightIconsSelected.onTimeSelected;
      case "delayed":
      case "DELAYED":
        return flightIconsSelected.delayedSelected;
      case "early":
      case "EARLY":
        return flightIconsSelected.earlySelected;
      default:
        return flightIconsSelected.defaultSelected;
    }
  } else {
    switch (status) {
      case "onTime":
      case "ON_TIME":
        return flightIcons.onTime;
      case "delayed":
      case "DELAYED":
        return flightIcons.delayed;
      case "early":
      case "EARLY":
        return flightIcons.early;
      default:
        return flightIcons.default;
    }
  }
}
